__turbopack_context__.v({
  "blue": "BottomActionBanner-module-scss-module__Zkwe-G__blue",
  "close_button": "BottomActionBanner-module-scss-module__Zkwe-G__close_button",
  "cornflower": "BottomActionBanner-module-scss-module__Zkwe-G__cornflower",
  "cyan": "BottomActionBanner-module-scss-module__Zkwe-G__cyan",
  "gray": "BottomActionBanner-module-scss-module__Zkwe-G__gray",
  "green": "BottomActionBanner-module-scss-module__Zkwe-G__green",
  "illust_icon": "BottomActionBanner-module-scss-module__Zkwe-G__illust_icon",
  "left": "BottomActionBanner-module-scss-module__Zkwe-G__left",
  "magenta": "BottomActionBanner-module-scss-module__Zkwe-G__magenta",
  "olive": "BottomActionBanner-module-scss-module__Zkwe-G__olive",
  "orange": "BottomActionBanner-module-scss-module__Zkwe-G__orange",
  "pink": "BottomActionBanner-module-scss-module__Zkwe-G__pink",
  "red": "BottomActionBanner-module-scss-module__Zkwe-G__red",
  "right": "BottomActionBanner-module-scss-module__Zkwe-G__right",
  "sub_title": "BottomActionBanner-module-scss-module__Zkwe-G__sub_title",
  "text_button": "BottomActionBanner-module-scss-module__Zkwe-G__text_button",
  "title": "BottomActionBanner-module-scss-module__Zkwe-G__title",
  "violet": "BottomActionBanner-module-scss-module__Zkwe-G__violet",
  "wrap": "BottomActionBanner-module-scss-module__Zkwe-G__wrap",
  "yellow": "BottomActionBanner-module-scss-module__Zkwe-G__yellow",
});
